<template>
    <div v-if="status !== 'loading'" class="pardakht-shakhsi-bg">
        <receipt-form
                v-if="receipt_form_data.payment_found"
                :form_data="receipt_form_data"
        ></receipt-form>
        <kt-panel v-else>
            <kt-panel-body>
                <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                    {{ $t('message.payment_page_not_found') }}
                </p>
            </kt-panel-body>
        </kt-panel>
    </div>
    <loader v-else></loader>
</template>

<script>
    import receiptForm from "./components/receipt-form"
    import Loading from '@/components/custom/loading'
    import {mapGetters} from "vuex";

    export default {
        name: "Checkout",

        components: {
            'receipt-form': receiptForm,
            'loader': Loading
        },
        computed: {
            ...mapGetters('pardakhtShakhsi', ['receipt_form_data', 'status']),
        },

        data() {
            return {
                'tracking_code': this.$route.params.tracking_code
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.$store.dispatch('pardakhtShakhsi/receiptData', vm.tracking_code)
            })
        },
    }
</script>

<style scoped>
    .pardakht-shakhsi-bg {
        background: url("./assets/pardakht-shakhsi-bg.jpg");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        margin: auto;
        width: 100%;
        height: 100%;
    }

</style>